// Reglas de la pantalla para habilitar o deshabilitar un deporte de una org. La base
// vuelve a revisar todo (deshabilitar_deporte_org / habilitar_deporte_org): esto solo
// decide que se muestra y cuando se puede apretar el boton.

// Mismas etiquetas que public._resumen_conteos (migracion 20261001_deportes_proceso_controlado).
const RECURSOS = [
  ['grupos', 'grupo', 'grupos'],
  ['categorias', 'categoría', 'categorías'],
  ['prendas', 'prenda', 'prendas'],
  ['plantillas', 'plantilla de sección', 'plantillas de sección'],
  ['habilidades', 'habilidad', 'habilidades'],
  ['inventario', 'artículo de inventario', 'artículos de inventario'],
  ['programas', 'programa de entrenamiento', 'programas de entrenamiento'],
]

export const MOTIVO_MIN = 5

export const resumenConteos = (conteos) =>
  RECURSOS
    .map(([llave, uno, varios]) => {
      const n = Number(conteos?.[llave]) || 0
      return n > 0 ? `${n} ${n === 1 ? uno : varios}` : null
    })
    .filter(Boolean)

// La bitacora guarda IDs; el historial muestra cuantos.
export const conteosDeIds = (ids) =>
  Object.fromEntries(Object.entries(ids || {}).map(([k, v]) => [k, Array.isArray(v) ? v.length : 0]))

const normalizar = (s) => (s || '').trim().toLowerCase()

// Por que no se puede hacer el cambio, en palabras. Vacio = se puede.
export const impedimentos = (accion, impacto) => {
  if (!impacto) return []
  if (accion === 'deshabilitar') {
    if (impacto.ultimo_deporte) return ['Es el único deporte de la organización: no se puede deshabilitar.']
    return (impacto.bloqueos || []).map((b) => b.etiqueta)
  }
  const tope = impacto.tope_plan
  if (tope && !tope.exento && tope.usados >= tope.maximo) {
    const palabra = tope.maximo === 1 ? 'deporte' : 'deportes'
    return [`El plan de esta organización permite ${tope.maximo} ${palabra}. Sube el plan para habilitar más.`]
  }
  return []
}

export const puedeConfirmar = ({ accion, impacto, motivo, confirmacion, nombreDeporte }) => {
  if (!impacto || impedimentos(accion, impacto).length > 0) return false
  if ((motivo || '').trim().length < MOTIVO_MIN) return false
  if (accion === 'deshabilitar' && normalizar(confirmacion) !== normalizar(nombreDeporte)) return false
  return true
}
